import "core-js/stable";
import "regenerator-runtime/runtime";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { ReadingWorkbench } from "@reading/components/ReadingWorkbench";

ReactDOM.render(
  <ReadingWorkbench review={false} />,
  document.getElementById("root") as HTMLElement,
);
